import BodyComponent from "./bodyComponent";
import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";


export default function MainHomeComponent() {

    return (
        <div>
            <NavigationBar />
            <BodyComponent />
            <FooterComponent />
        </div>
    )
}